import styled from 'styled-components'
import { Button as BootstrapButton } from 'react-bootstrap'

export interface ButtonProps {
  $variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'outline'
  $size?: 'sm' | 'md' | 'lg'
  $fullWidth?: boolean
}

export const BaseButton = styled(BootstrapButton)<ButtonProps>`
  border-radius: ${({ theme }) => theme.borderRadius.md};
  transition: ${({ theme }) => theme.transitions.fast};
  font-weight: 500;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

  ${({ $size, theme }) => {
    switch ($size) {
      case 'sm':
        return `
          padding: ${theme.spacing.xs} ${theme.spacing.sm};
          font-size: 0.875rem;
        `
      case 'lg':
        return `
          padding: ${theme.spacing.md} ${theme.spacing.lg};
          font-size: 1.125rem;
        `
      default:
        return `
          padding: ${theme.spacing.sm} ${theme.spacing.md};
          font-size: 1rem;
        `
    }
  }}

  ${({ $variant, theme }) => {
    switch ($variant) {
      case 'outline':
        return `
          background: transparent;
          border: 2px solid ${theme.colors.primary};
          color: ${theme.colors.primary};
          
          &:hover {
            background: ${theme.colors.primary};
            color: ${theme.colors.text.light};
          }
        `
      case 'secondary':
        return `
          background: ${theme.colors.secondary};
          border: none;
          color: ${theme.colors.text.light};
          
          &:hover {
            background: ${theme.colors.gradients.secondary};
          }
        `
      default:
        return `
          background: ${theme.colors.primary};
          border: none;
          color: ${theme.colors.text.light};
          
          &:hover {
            background: ${theme.colors.gradients.primary};
          }
        `
    }
  }}
`
